var _rect, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 18,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 10,
    y2: 14
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 16,
    y2: 14
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 10,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.568b5e42f51bdbb6a8d1b07d56b2fb19.svg";
export { ForwardRef as ReactComponent };